import React, { FC, useEffect, useState } from "react";
import { Dialog } from "../new-components/dialog";
import { useSiteContext } from "../../shared/context/site-state.context";
import { useTranslation } from "react-i18next";

interface Props {}

const CloseSiteDialog: FC<Props> = () => {
  const [showDialog, setShowDialog] = useState(false);
  const { isClosed, isDeliveryDisabled } = useSiteContext();
  const { t } = useTranslation();

  // A closed restaurant is the bigger news, so it wins over the delivery notice
  const variant = isClosed
    ? "restaurantClosed"
    : isDeliveryDisabled
    ? "deliveryDisabled"
    : null;

  useEffect(() => {
    setShowDialog(Boolean(variant));
  }, [variant]);

  if (!variant) return null;

  return (
    <Dialog
      open={showDialog}
      onClose={() => setShowDialog(false)}
      title={t(`closeSite.${variant}.title`)}
      description={t(`closeSite.${variant}.description`)}
      description2={t(`closeSite.${variant}.description2`)}
      confirmButtonText={t(`closeSite.${variant}.understandButton`)}
      onConfirm={() => setShowDialog(false)}
    />
  );
};

export default CloseSiteDialog;
